import React, { memo } from 'react';
import { TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Text,
  IconArrowDown,
  IconArrowUp,
  Space,
} from '@redlink/components/atoms';

export const DataGridColumnHeader = memo(
  ({ sortKey, title, sortable, flex, sortBy, sortByDirection, onSort }) => {
    const { styles } = useStyle();
    const isSortField = sortBy === sortKey;
    const isDescSortDirection = sortByDirection === 'desc';

    return (
      <TouchableOpacity
        disabled={!sortable}
        onPress={() => onSort?.(sortKey, isDescSortDirection ? 'asc' : 'desc')}
        activeOpacity={0.7}
        style={[styles.container, { flex }]}
      >
        <Text style={styles.titleText}>{title}</Text>
        <Space size={5} />
        {sortable &&
          isSortField &&
          (!isDescSortDirection ? (
            <IconArrowUp size={15} />
          ) : (
            <IconArrowDown size={15} />
          ))}
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  titleText: {
    color: colors.gray23,
    fontSize: 12,
  },
}));
